import { getIdentifiedPlatformConfig } from '@hmhco/login-config';

export const redirectToCentralLogin = (timeout = 3000) => {
  const { nweaStartUrl } = getIdentifiedPlatformConfig();

  setTimeout(() => {
    if (nweaStartUrl) {
      window.location.href = nweaStartUrl;
    } else {
      window.location.href = `${window.location.origin}/ui/login`;
    }
  }, [timeout]);
};

export default redirectToCentralLogin;
